import { Box, Collapse, Grid, useTheme } from '@mui/material'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AppRoutesNavigation } from 'src/app-routes'
import NoServiceStations from 'src/assets/svg/no-locality-content.svg'
import NoServiceStationCustomers from 'src/assets/svg/no-service-station-customers.svg'
import { EmptyStatusCard } from 'src/components/mooring/EmptyStatusCard'
import { CustomerHeader } from 'src/components/sidemenu/CustomerHeader'
import { ICustomer } from 'src/generated-types'
import { IStorage } from 'src/generated-types/storage-types'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import StorageCard from './StorageCard'

const UserAllStorages: React.FC<{
  customers: ICustomer[] | undefined
  open: number
  setOpen: (value: any) => void
}> = ({ customers, open, setOpen }) => {
  const { t: translate } = useTranslation(['service-station'])
  const navigate = useNavigate()
  const theme = useTheme()
  return (
    <Box height={'100%'} maxHeight={window.innerHeight - 162} overflow={'auto'}>
      {customers?.length === 0 ? (
        <Box
          py={8}
          className="text-center"
          height={'100%'}
          bgcolor={getThemeColor(theme, MUIThemeColors.white)}
          border={'1px solid #d8e1e7;'}
        >
          <EmptyStatusCard
            imageWidth="132px"
            image={NoServiceStationCustomers}
            header={translate('storage-empty-status-title', { ns: 'storage' })}
            content={translate('storage-empty-status-content', { ns: 'storage' })}
            headerFontSize="18px"
            contentFontSize="14px"
            contentTopMargin="10px"
            imageContainerClasses="pb-4"
            height="100%"
            contentClasses="mt-1"
          />
        </Box>
      ) : (
        customers?.map((customer: ICustomer, index: number) => {
          return (
            <Box key={index}>
              <Box padding={0.5}>
                <CustomerHeader
                  hasAdminAccess={customer.isAdminCustomer}
                  isLandingPage={true}
                  {...customer}
                  onClick={() => {
                    localStorage.setItem('currentCustomerId', customer.id.toString())
                    if (customer.isAdminCustomer)
                      localStorage.setItem('selectedCustomerAdminCustomerId', customer.id.toString())
                    setOpen(value => (value == customer.id ? 0 : customer.id))
                  }}
                  active={open == customer.id}
                  isServiceStation={true}
                />
              </Box>
              <Collapse
                in={open == customer.id}
                sx={{ paddingTop: '12px', paddingBottom: '16px', paddingLeft: '4px', paddingRight: '4px' }}
              >
                {customer?.storages?.length != 0 ? (
                  <Grid container className="overflow-y-auto " maxHeight={'82vh'} spacing={'11px'}>
                    {customer.storages?.map((storage: IStorage, index: number) => {
                      return (
                        <Grid item md={3} xs={6} key={index}>
                          <StorageCard
                            storage={storage}
                            active={true}
                            onClick={() => navigate(AppRoutesNavigation.storage.storage(customer?.id, storage.id))}
                          />
                        </Grid>
                      )
                    })}
                  </Grid>
                ) : (
                  <Box py={8} className="text-center" height={'100%'}>
                    <EmptyStatusCard
                      imageWidth="132px"
                      image={NoServiceStations}
                      header={translate('customer-storage-empty-status-title', { ns: 'storage' })}
                      content={translate('customer-storage-empty-status-content', { ns: 'storage' })}
                      headerFontSize="18px"
                      contentFontSize="14px"
                      contentTopMargin="10px"
                      imageContainerClasses="pb-4"
                      height="100%"
                      contentClasses="mt-1"
                    />
                  </Box>
                )}
              </Collapse>
            </Box>
          )
        })
      )}
    </Box>
  )
}

export default UserAllStorages
